module.exports = __webpack_public_path__ + "img/1.b276cc70.jpg";